import { Component, inject, OnInit, ViewChild, EventEmitter, Output, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FgjsService, ILivingComplex, ILivingComplexUser, IUserObjectData } from '../fgjs.service';
import {MatRadioModule} from '@angular/material/radio';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-add-object',
  templateUrl: './add-object.component.html',
  styleUrl: './add-object.component.scss'
})
export class AddObjectComponent {
  buildings: ILivingComplex[] = [];
  displayedColumns = ['radioButton', 'complexId', 'complexName'];
  complexes: MatTableDataSource<ILivingComplex>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Output() complexSelected = new EventEmitter<ILivingComplex>();

  selectedComplex: ILivingComplex | null = null;
  selectComp: ILivingComplexUser[] = [];

  totalItems: number = 0;
  pageSize: number = 5;
  pageSizeOptions: number[] = [5, 10, 20];

  searchTerm: string;
  isSearchMode: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<AddObjectComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IUserObjectData,
    private snackBar: MatSnackBar,
    private paginatorRus: MatPaginatorIntl,
    private service: FgjsService
  ){
    paginatorRus.itemsPerPageLabel = 'Количество объектов на странице';
    paginatorRus.nextPageLabel = 'Следующая страница';
    paginatorRus.previousPageLabel = 'Предыдущая страница';
    paginatorRus.lastPageLabel = 'Последняя страница';
    paginatorRus.firstPageLabel = 'Первая страница';
  }

  ngOnInit(){
    this.loadLivingComplexes();
    this.loadSelection(this.data.id);
  }

  search(event?: PageEvent) {
    this.isSearchMode = true;
    const pageNumber = event ? event.pageIndex + 1 : this.paginator.pageIndex + 1;
    const pageSize = event ? event.pageSize : this.paginator.pageSize;

    if (this.searchTerm) {
      const isId = !isNaN(Number(this.searchTerm));

      if (isId) {
        this.searchById(Number(this.searchTerm), pageNumber, pageSize);
      } else {
        this.searchByTitle(this.searchTerm, pageNumber, pageSize);
      }
    }
  }

  private searchById(id: number, pageNumber: number, pageSize: number) {
    this.service.searchLivingComplexesById(id, pageNumber, pageSize).subscribe(
      (res: any) => this.handleSearchResult(res)
    );
  }

  private searchByTitle(title: string, pageNumber: number, pageSize: number) {
    this.service.searchLivingComplexesByTitle(title, pageNumber, pageSize).subscribe(
      (res: any) => this.handleSearchResult(res)
    );
  }

  private handleSearchResult(res: any) {
    this.buildings = res.objects.map(r => ({
      id: r.id,
      name: r.name,
      isCompleted: r.isCompleted
    }));
    console.log(res);
    this.totalItems = res.objects.length;
    this.loadTable();
  }

  loadSelection(id) {
    this.service.getComplexUser(id).subscribe((res: any) => {
      this.selectComp = res;
    })
  }

  showSelectedObject() {
    const bc = this.buildings.find(f => f.id === this.selectComp[0]?.livingComplexID)
    if (this.selectComp.length && !bc) {
      let selectedEntry: any = this.selectComp?.map(r => {
        return {
          id: r.livingComplexID,
          name: r.livingComplexTitle,
          isCompleted: false
        }
      })
      this.buildings.unshift(selectedEntry[0]);
      //console.log(this.buildings);
    }
    this.loadTable();
  }

  loadLivingComplexes(event?: PageEvent) {
    const pageNumber = event ? event.pageIndex + 1 : 1;
    const pageSize = event ? event.pageSize : this.pageSize;
    let selectLv = [];
    this.service.getLivingComplexesPaginated(pageNumber, pageSize)
      .subscribe(
        (response: any) => {
          selectLv = this.data.anchoredLvComplex.reduce((acc, cur) => {
            if (!(!!this.selectComp.find(el => el.livingComplexID == cur.livingComplexID))) acc.push(cur);
            return acc;
          }, []);
          this.buildings = response.objects.map(r => {
            return {
              id: r.id,
              name: r.name,
              isCompleted: r.isCompleted,
              disabled: !!selectLv.find(el => el.livingComplexID == r.id)
            }
          });
          this.totalItems = response.infoByRegion[0].totalcnt;
          this.showSelectedObject();
          //this.loadTable();
        }
      );
  }

  loadTable(){
    this.complexes = new MatTableDataSource(this.buildings.filter(f => f.isCompleted === false));
  }

  applyFilter(event: Event) {
    this.complexes.filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
  }

  onComplexSelected(complex: ILivingComplex) {
    this.selectedComplex = complex;
  }

  okClick() {
    if (this.selectedComplex) {
      this.complexSelected.emit(this.selectedComplex);
      this.snackBar.open('Объект успешно добавлен!', '', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'right',
        panelClass: ['snackbar-succes']
      });
      this.dialogRef.close();
    } else {
      this.snackBar.open('Вы не выбрали объект!', '', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'right',
        panelClass: ['snackbar-error']
      });
    }
  }
}
